import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Icon, Table, Responsive } from 'semantic-ui-react';
import { Field } from 'redux-form';
import _ from 'lodash';

import { SelectField, TextAreaField } from 'Common/SemanticWrapper';
import {
  PreparationInstructionEnum as Fields,
  IngredientFieldEnum as IngredientFields,
  PreparationInstructionIngredientEnum as PreparationIngredientFields,
} from 'Common/FieldEnum';
import { HACCP_POSITION } from 'Pages/managerecipe/helpers/constants';

const IngredientList = ({
  prepIngs,
  ingredients,
  instruction,
  handleAddIngredientToDescriptionClick,
  handleOpenIngredientModalClick,
  handleConfirmRemoveIngredient,
  isReadOnly,
}) => (
  <div style={{ padding: '8px 0' }}>
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={9}>Ingredient / Sub Recipe</Table.HeaderCell>
          <Table.HeaderCell width={1} textAlign="center">
            Quantity
          </Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign="center">
            Measure
          </Table.HeaderCell>
          <Table.HeaderCell width={1} textAlign="center">
            Quantity
          </Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign="center">
            Measure
          </Table.HeaderCell>
          <Table.HeaderCell width={1} />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {prepIngs.map((prepIng, index) => {
          const ingredient = ingredients.find(
            (i) =>
              i[IngredientFields.Id] ===
                prepIng[PreparationIngredientFields.Id] &&
              i[IngredientFields.IngIndex] ===
                prepIng[PreparationIngredientFields.Index]
          );
          if (!ingredient) {
            return null;
          }
          return (
            <Table.Row
              key={`${ingredient[IngredientFields.Id]}-${
                ingredient[IngredientFields.IngIndex]
              }-${index}`}
            >
              <Table.Cell>
                {ingredient[IngredientFields.IngredientName]}
              </Table.Cell>
              <Table.Cell textAlign="center">
                {ingredient[IngredientFields.Quantity1]}
              </Table.Cell>
              <Table.Cell textAlign="center">
                {ingredient[IngredientFields.Measure1]}
              </Table.Cell>
              <Table.Cell textAlign="center">
                {ingredient[IngredientFields.Quantity2]}
              </Table.Cell>
              <Table.Cell textAlign="center">
                {ingredient[IngredientFields.Measure2]}
              </Table.Cell>
              <Table.Cell style={{ whiteSpace: 'nowrap' }} textAlign="center">
                <Icon
                  name="plus"
                  onClick={() =>
                    handleAddIngredientToDescriptionClick(
                      ingredient,
                      instruction
                    )
                  }
                  disabled={isReadOnly}
                  link
                />
                <Icon
                  name="trash"
                  onClick={() =>
                    handleConfirmRemoveIngredient(
                      ingredient[IngredientFields.Id],
                      prepIng[PreparationIngredientFields.Index],
                      instruction
                    )
                  }
                  disabled={isReadOnly}
                  link
                />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
    <Button
      floated="right"
      style={{ marginBottom: 10 }}
      onClick={() => handleOpenIngredientModalClick(instruction)}
      disabled={isReadOnly}
    >
      <Icon name="plus" />
      Add Ingredient
    </Button>
  </div>
);

const HACCPList = ({
  haccpInstructions,
  haccpsMap,
  haccpTypesMap,
  instruction,
  handleOpenHACCPModalClick,
  handleConfirmRemoveHACCPInstruction,
  isReadOnly,
}) => (
  <React.Fragment>
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3}>HACCP Position</Table.HeaderCell>
          <Table.HeaderCell width={3}>HACCP Type</Table.HeaderCell>
          <Table.HeaderCell width={5}>HACCP Critical Limit</Table.HeaderCell>
          <Table.HeaderCell width={4}>HACCP Notes</Table.HeaderCell>
          <Table.HeaderCell width={1} />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {haccpInstructions.map((haccpInstruction) => (
          <Table.Row key={haccpInstruction[Fields.Id]}>
            <Table.Cell>
              {_.get(
                HACCP_POSITION,
                `${haccpInstruction[Fields.Position]}.${Fields.Description}`
              )}
            </Table.Cell>
            <Table.Cell>
              {_.get(
                haccpTypesMap,
                `${haccpInstruction[Fields.TypeId]}.${Fields.Description}`
              )}
            </Table.Cell>
            <Table.Cell>
              {_.get(
                haccpsMap,
                `${haccpInstruction[Fields.HACCPCriticalLimitId]}.${
                  Fields.Description
                }`
              )}
            </Table.Cell>
            <Table.Cell>{haccpInstruction[Fields.HACCPNotes]}</Table.Cell>
            <Table.Cell>
              <Icon
                name="trash"
                onClick={() =>
                  handleConfirmRemoveHACCPInstruction(
                    haccpInstruction[Fields.Id],
                    instruction
                  )
                }
                disabled={isReadOnly}
                link
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    <Button
      floated="right"
      style={{ marginBottom: 10 }}
      onClick={() => handleOpenHACCPModalClick(instruction)}
      disabled={isReadOnly}
    >
      <Icon name="plus" />
      Add HACCP
    </Button>
  </React.Fragment>
);

const ControlsComponent = ({
  instruction,
  availableSteps,
  instructionDescriptionOptions,
  handleConfirmRemoveStep,
  isReadOnly,
}) => (
  <Grid.Row>
    <Grid.Column width={4}>
      <Field
        component={SelectField}
        label={'Step'}
        name={`${instruction}.${Fields.Step}`}
        fluid
        options={availableSteps}
        disabled={isReadOnly}
      />
    </Grid.Column>
    <Grid.Column width={7}>
      <Field
        component={SelectField}
        label={'Description'}
        name={`${instruction}.${Fields.DescriptionId}`}
        fluid
        options={instructionDescriptionOptions}
        disabled={isReadOnly}
      />
    </Grid.Column>
    <Grid.Column width={5} style={{ display: 'flex', alignItems: 'flex-end' }}>
      <Button
        fluid
        onClick={() => handleConfirmRemoveStep(instruction)}
        disabled={isReadOnly}
      >
        <Icon name="trash" />
        Remove Step
      </Button>
    </Grid.Column>
  </Grid.Row>
);

class PreparationInstruction extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    instruction: PropTypes.string.isRequired,
    ingredients: PropTypes.array.isRequired,
    ingredientsMap: PropTypes.object.isRequired,
    haccpsMap: PropTypes.object.isRequired,
    haccpTypesMap: PropTypes.object.isRequired,
    availableSteps: PropTypes.array.isRequired,
    instructionDescriptionOptions: PropTypes.array.isRequired,
    handleOpenIngredientModalClick: PropTypes.func.isRequired,
    handleOpenHACCPModalClick: PropTypes.func.isRequired,
    handleAddIngredientToDescriptionClick: PropTypes.func.isRequired,
    handleConfirmRemoveHACCPInstruction: PropTypes.func.isRequired,
    handleConfirmRemoveIngredient: PropTypes.func.isRequired,
    handleConfirmRemoveStep: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    isReadOnly: false,
  };

  render() {
    const {
      data,
      instruction,
      ingredients,
      haccpsMap,
      haccpTypesMap,
      availableSteps,
      instructionDescriptionOptions,
      handleOpenIngredientModalClick,
      handleOpenHACCPModalClick,
      handleAddIngredientToDescriptionClick,
      handleConfirmRemoveHACCPInstruction,
      handleConfirmRemoveIngredient,
      handleConfirmRemoveStep,
      isReadOnly,
    } = this.props;

    const prepIngs = _.get(data, `${instruction}.${Fields.Ingredients}`, []);
    const haccpInstructions = _.get(
      data,
      `${instruction}.${Fields.HACCPInstructions}`
    );

    return (
      <React.Fragment>
        <Responsive as={Grid} minWidth={1401} columns={2} padded celled>
          <Grid.Row>
            <Grid.Column width={6}>
              <Grid>
                <ControlsComponent
                  instruction={instruction}
                  availableSteps={availableSteps}
                  instructionDescriptionOptions={instructionDescriptionOptions}
                  handleConfirmRemoveStep={handleConfirmRemoveStep}
                  isReadOnly={isReadOnly}
                />
                <Grid.Row>
                  <Grid.Column width={16}>
                    <IngredientList
                      prepIngs={prepIngs}
                      ingredients={ingredients}
                      handleAddIngredientToDescriptionClick={
                        handleAddIngredientToDescriptionClick
                      }
                      instruction={instruction}
                      handleOpenIngredientModalClick={
                        handleOpenIngredientModalClick
                      }
                      handleConfirmRemoveIngredient={
                        handleConfirmRemoveIngredient
                      }
                      isReadOnly={isReadOnly}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={10}>
              <Field
                component={TextAreaField}
                label={'Directions'}
                name={`${instruction}.${Fields.Directions}`}
                disabled={isReadOnly}
              />
              <HACCPList
                haccpInstructions={haccpInstructions}
                haccpsMap={haccpsMap}
                haccpTypesMap={haccpTypesMap}
                handleOpenHACCPModalClick={handleOpenHACCPModalClick}
                handleConfirmRemoveHACCPInstruction={
                  handleConfirmRemoveHACCPInstruction
                }
                instruction={instruction}
                isReadOnly={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </Responsive>
        <Responsive as={Grid} maxWidth={1400} padded celled>
          <Grid.Row>
            <Grid.Column width={16}>
              <Grid>
                <ControlsComponent
                  instruction={instruction}
                  availableSteps={availableSteps}
                  instructionDescriptionOptions={instructionDescriptionOptions}
                  handleConfirmRemoveStep={handleConfirmRemoveStep}
                />
                <Grid.Row>
                  <Grid.Column width={16}>
                    <IngredientList
                      prepIngs={prepIngs}
                      ingredients={ingredients}
                      handleAddIngredientToDescriptionClick={
                        handleAddIngredientToDescriptionClick
                      }
                      instruction={instruction}
                      handleOpenIngredientModalClick={
                        handleOpenIngredientModalClick
                      }
                      handleConfirmRemoveIngredient={
                        handleConfirmRemoveIngredient
                      }
                      isReadOnly={isReadOnly}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ boxShadow: 'unset' }}>
            <Grid.Column width={16}>
              <Field
                component={TextAreaField}
                label={'Directions'}
                name={`${instruction}.${Fields.Directions}`}
                disabled={isReadOnly}
              />
              <HACCPList
                haccpInstructions={haccpInstructions}
                haccpsMap={haccpsMap}
                haccpTypesMap={haccpTypesMap}
                handleOpenHACCPModalClick={handleOpenHACCPModalClick}
                handleConfirmRemoveHACCPInstruction={
                  handleConfirmRemoveHACCPInstruction
                }
                instruction={instruction}
                isReadOnly={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </Responsive>
      </React.Fragment>
    );
  }
}

export { PreparationInstruction };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/PreparationInstructions/PreparationInstruction.js